<template>
	<v-alert class="rounded" :color="backgroundColor"
			 :class="`px-${px} ${noTextCaption ? '' : 'text-caption py-3'}`"
			 :style="alertStyle"
			 dense>
		<div class="d-flex align-center">
			<rmp-icon :width="iconSize" :height="iconSize" :src="icon" :color="backgroundColor" class="mr-2"></rmp-icon>
			<slot>
				{{ text }}
			</slot>
		</div>
	</v-alert>
</template>

<script setup lang="ts">
import RmpIcon from "@rmp/core/components/icon/RmpIcon.vue";
import { useAlert } from "@rmp/core/composables/useAlert";
import { computed } from "vue";

export interface AlertProps {
	customBackgroundColor?: string;
	customIcon?: string;
	iconColor?: string;
	text?: string;
	noTextCaption?: boolean;
	iconSize?: string | number;
	type?: string;
	px?: string | number;
	width?: string;
	maxWidth?: string;
	height?: string;
}

const props = withDefaults(defineProps<AlertProps>(), {
	iconSize: "24",
	type: "info",
	px: 4,
	noTextCaption: true
});

const {
	type,
	customIcon,
	backgroundColor
} = useAlert(props);

const icon = computed(() => {
	return customIcon.value || `ico_${type.value}`;
});

const alertStyle = computed(() => ({
	backgroundColor: `${backgroundColor.value}26 !important`,
	color: `${backgroundColor.value} !important`,
	width: props.width ? props.width : "fit-content",
	maxWidth: props.maxWidth ? props.maxWidth : "unset",
	height: props?.height ? props?.height : "unset",
}));
</script>

<style scoped lang="scss">
</style>
